import React, { Component } from 'react';
import Model from './model';
import View from './view';
import Presenter from './presenter';
import Alert from '../../util/alert';

export default class CountryPopup extends Component {
  static show(selectedCountry, onClose, onComplete, onError) {
    Alert.show((id, close) => (open) => (
      <CountryPopup
        key={`country-${id}`}
        open={open}
        selectedCountry={selectedCountry}
        onError={(error) => {
          onError?.(error);
          close();
        }}
        onComplete={(country) => {
          onComplete?.(country);
          close();
        }}
        onClose={() => {
          onClose?.();
          close();
        }}
      />
    ));
  }

  constructor(props) {
    super(props);
    const { onClose, onComplete, onError } = props;
    this.state = { countries: [] };
    this.presenter = new Presenter(new Model(this), onClose, onComplete, onError);
  }

  componentDidMount() {
    this.presenter.onAttach();
  }

  componentDidUpdate() {
    const { onClose } = this.props;
    this.presenter.onClose = onClose;
  }

  render() {
    const { selectedCountry, open, action } = this.props;
    return (
      <View
        {...this.state}
        selectedCountry={selectedCountry}
        action={action}
        presenter={this.presenter}
        open={open}
      />
    );
  }
}
